import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const ToolImageGallery = ({ images, toolName }) => {
  if (!images || images.length === 0) {
    return null;
  }

  const singleImageStyle = {
    width: '100%',
    maxHeight: 'calc(-64px + 60vh)',
    objectFit: 'contain',
    borderRadius: '8px',
  };

  if (images.length === 1) {
    return (
      <div className="mb-8 tool-carousel-container single-image-container">
        <img src={images[0]} alt={`${toolName}`} style={singleImageStyle} />
        <style jsx>{`
          .single-image-container {
            height: calc(-64px + 60vh);
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="mb-8 tool-carousel-container">
      <Carousel
        showStatus={false}
        showThumbs={true}
        infiniteLoop={true}
        dynamicHeight={false}
        emulateTouch={true}
        swipeable={true}
        centerMode={false}
        showIndicators={false}
        className="tool-carousel"
      >
        {images.map((imageUrl, index) => (
          <div key={index} className="carousel-slide">
            <img src={imageUrl} alt={`${toolName} - ${index + 1}`} className="carousel-image" />
          </div>
        ))}
      </Carousel>
      <style jsx>{`
        .tool-carousel-container {
          height: calc(-64px + 60vh);
          display: flex;
          flex-direction: column;
        }
        .tool-carousel {
          flex-grow: 1;
          position: relative;
        }
        .carousel-slide {
          height: 100%;
        }
        .carousel-image {
          width: 100%;
          height: calc(-64px + 60vh - 100px); /* Adjust height to leave space for thumbnails */
          object-fit: contain;
          border-radius: 8px;
        }
        /* Custom styles for thumbnails */
        .carousel .thumbs-wrapper {
          margin: 10px 0 0;
          overflow: hidden;
        }
        .carousel .thumbs {
          display: flex;
          justify-content: center;
          padding: 0;
          margin: 0;
          list-style: none;
        }
        .carousel .thumb {
          width: 60px;
          height: 60px;
          border: 3px solid transparent;
          border-radius: 4px;
          margin: 0 5px;
          cursor: pointer;
          opacity: 0.7;
          transition: all 0.3s ease;
        }
        .carousel .thumb.selected,
        .carousel .thumb:hover {
          border-color: #333;
          opacity: 1;
        }
        .carousel .thumb img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
};

export default ToolImageGallery;
